import React, { useState, useEffect } from 'react';
import { useNavigate, Link, useParams } from 'react-router-dom';

import ArrowRightOrange from '../../assets/images/common/arrow-right-orange.svg';
import ArrowBackBlue from '../../assets/images/common/arrow-back-blue.svg';

import { ContactInputType, CONTACT_INPUT_INIT } from '../../types/common/ContactType';
import { TS_SCREEN, SCREEN_NAME } from '../../types/common/CommonType';

import { ContactInput } from './ContactInput';
import { ContactLogic } from './ContactLogic';
import { ErrorModalModal } from '../../components/ErrorModal';
import { setState as ScreenTransition } from '../../slice/ScreenTransitionSlice';
import { addRow as setMoveScreen } from '../../slice/ScreenHistorySlice';
import { useAppDispatch, useAppSelector } from '../../store/hooks';

type ContactProps = {
    contactInput: ContactInputType; // 問い合わせ入力情報
    setContactInput: (value: ContactInputType) => void; // 問い合わせ入力情報setState
};

// 問い合わせ画面
export const Contact: React.FC<ContactProps> = ({ contactInput, setContactInput }) => {
    const dispatch = useAppDispatch();
    const navigation = useNavigate();
    // 検索結果無での遷移か否か取得
    const urlParams = useParams<{ moveButton: string }>();
    // 検索文言
    const searchWord = useAppSelector((s) => s.SearchWord);
    // お問い合わせ種別、お問い合わせ理由のマスタ
    const masterInquireData = useAppSelector((s) => s.MasterInquire);

    // エラーメッセージ表示 - お問い合わせ種別
    const [inquireErrorMessage, setInquireErrorMessage] = useState<string>('');
    // エラーメッセージ表示 - お問い合わせ詳細・備考
    const [textErrorMessage, setTextErrorMessage] = useState<string>('');
    // エラーモーダル表示
    const [errorModalMessage, setErrorModalMessage] = useState<Array<string>>([]);
    // エラー モーダル開閉管理
    const [openErrorlModal, setOpenErrorModal] = useState<boolean>(false);
    // 検索結果なしの遷移フラグ
    const [noSearchWordFlg, setNoSearchWordFlg] = useState<boolean>(false);

    // 初期表示処理
    useEffect(() => {
        // 初期化判定
        if (urlParams.moveButton === 'noSearchWord') {
            // 検索結果が0件である場合、
            // お問い合わせに検索文言を表示
            setContactInput({
                ...contactInput,
                contactText: `「${searchWord}」に関するお問い合わせ\n—`,
            });
            setNoSearchWordFlg(true);
        } else if (
            urlParams.moveButton === 'header' ||
            urlParams.moveButton === 'topPage' ||
            urlParams.moveButton === 'error'
        ) {
            // ヘッダー、トップページ、エラーモーダルからの遷移であれば初期化
            setContactInput(CONTACT_INPUT_INIT);
            setNoSearchWordFlg(false);
        }
    }, [urlParams.moveButton]);

    // 画面遷移ルート追加
    useEffect(() => {
        dispatch(setMoveScreen(SCREEN_NAME.CONTACT));
    }, []);

    // 次へボタンアクション
    const moveCustomerInformation = () => {
        // バリデーション実行
        const tmpErrorModalMessage = ContactLogic.requiredInputValidation(
            contactInput,
            setInquireErrorMessage,
            setTextErrorMessage
        );

        if (tmpErrorModalMessage.length > 0) {
            // エラーの場合
            setErrorModalMessage(tmpErrorModalMessage);
            setOpenErrorModal(true);
        } else {
            // エラーではない場合
            // 画面遷移種別を更新
            dispatch(ScreenTransition(TS_SCREEN.CONTACT));
            // 顧客情報入力画面へ遷移
            navigation('/customerInformation');
        }
    };

    return (
        <>
            <section className='section page_title up_top_title'>
                <div className='container'>
                    <div className='columns is-tablet'>
                        <div className='column is-6-widescreen-only is-6-tablet is-12-mobile page_title-thead'>
                            <h1>お問い合わせ</h1>
                            <p className='discription'>下記に関する内容を入力してください。</p>
                        </div>
                        <div className='column is-6-widescreen-only is-6-tablet is-12-mobile'>
                            <div className='contact-info'>
                                <p className=''>
                                    「基盤移行」「更改プロジェクトの遅延リスク対策」
                                    <br />
                                    「ご計画立案時のご相談」なども承っております。
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='section content-wrapper up_top form'>
                <div className='container'>
                    <ContactInput
                        dataInput={true}
                        contactInput={contactInput}
                        setContactInput={setContactInput}
                        inquireErrorMessage={inquireErrorMessage}
                        textErrorMessage={textErrorMessage}
                        masterInquireData={masterInquireData}
                    />
                </div>
            </section>
            <section className='section bottom_cta'>
                <div className='container'>
                    <div className='columns'>
                        <div className='column'>
                            <div className='bottom_cta--next'>
                                <p className='bottom_cta--next_text'>
                                    内容がよろしければ、
                                    <br className='is-hidden-tablet' />
                                    次にお客様情報を入力してください。
                                </p>

                                <a className='button is-dl_blue' onClick={moveCustomerInformation}>
                                    次へ
                                    <span className='icon is-small'>
                                        <img src={ArrowRightOrange} alt='' />
                                    </span>
                                </a>
                                {noSearchWordFlg === true && (
                                    <Link to='/searchResult' className='button is-buck'>
                                        戻る
                                        <span className='icon is-small'>
                                            <img src={ArrowBackBlue} alt='' />
                                        </span>
                                    </Link>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <ErrorModalModal
                errorMessages={errorModalMessage}
                openState={openErrorlModal}
                setOpenState={setOpenErrorModal}
            />
        </>
    );
};
